import { createAsyncThunk } from "@reduxjs/toolkit";
import { useCustomAxios } from "../../shared/lib/customAxios";
import {
  API_ENDPOINTS,
} from "../../shared/constants/constants";

export const getAllOrders = createAsyncThunk(
  "order/get/all",
  async (parameter: any, { rejectWithValue }) => {
    const { axiosGet } = useCustomAxios();
    let url = API_ENDPOINTS.getAllOrders;

    // encodeURIComponent is required, not cosmetic: startDate/endDate are raw
    // Date objects here, and Date#toString() produces e.g. "Sat Aug 01 2026
    // 00:00:00 GMT+0530 (India Standard Time)" - the unencoded "+" in the
    // timezone offset gets decoded as a literal space by standard
    // application/x-www-form-urlencoded query parsing, corrupting the date
    // before the backend ever parses it (see the identical fix in grn.ts).
    Object.entries(parameter).forEach(
      ([key, value], index) =>
        (url = url + `${index > 0 ? "&" : "?"}${key}=${encodeURIComponent(String(value))}`)
    );

    try {
      const response = await axiosGet(url);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getOrderPdf = createAsyncThunk(
  "order/pdf",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    let url = API_ENDPOINTS.getOrderPdf;

    try {
      const response = await axiosPost(`${url}`, reqBody);
      const downloadURL = response.data.downloadURL;
      const downloadLink = document.createElement("a");
      document.body.appendChild(downloadLink);
      downloadLink.href = downloadURL;
      downloadLink.download = "order.pdf";
      downloadLink.target = "_blank";
      downloadLink.click();
      document.body.removeChild(downloadLink);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateOrderStatus = createAsyncThunk(
  "order/update/status",
  async (reqBody: any, { rejectWithValue }) => {
    const { axiosPost } = useCustomAxios();
    let url = `${API_ENDPOINTS.updateOrderStatus}`;
    url = url.replace(":orderId", reqBody?.orderId);
    try {
      const response = await axiosPost(`${url}`, reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return rejectWithValue(error.response.data.message);
    }
  }
);